"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _ReactionStore = require("@/libs/ReactionStore");
var _default = exports.default = {
  name: 'MessageReactions',
  props: {
    message: Object,
    buffer: Object
  },
  data: function data() {
    return {
      reactionStore: _ReactionStore.store
    };
  },
  computed: {
    stableId: function stableId() {
      return (0, _ReactionStore.getStableId)(this.message);
    },
    reactions: function reactions() {
      if (!this.reactionStore || !this.stableId) return {};
      return this.reactionStore[this.stableId] || {};
    },
    hasReactions: function hasReactions() {
      return (0, _keys.default)(this.reactions).length > 0;
    },
    network: function network() {
      return this.buffer ? this.buffer.getNetwork() : null;
    },
    myNick: function myNick() {
      return this.network ? this.network.nick : '';
    }
  },
  methods: {
    isMine: function isMine(nicks) {
      return nicks.indexOf(this.myNick) !== -1;
    },
    toggle: function toggle(emoji) {
      var remove = this.isMine(this.reactions[emoji] || []);
      var net = this.network;
      var serverMsgId = this.message.tags && this.message.tags.msgid;

      // IMPORTANT: Always prefer server msgid if available, otherwise use stable ID
      var id = serverMsgId || this.stableId;
      if (!net || !id || !this.buffer) {
        return;
      }

      // Apply optimistic local update FIRST using the preferred ID
      (0, _ReactionStore.applyReaction)(id, emoji, this.myNick, remove);

      // If we're using stable ID but have a server msgid, also apply to server msgid
      // This ensures cross-client consistency
      if (serverMsgId && this.stableId !== serverMsgId) {
        (0, _ReactionStore.applyReaction)(serverMsgId, emoji, this.myNick, remove);
      }

      // Send TAGMSG to server with the preferred ID
      var m = new net.ircClient.Message('TAGMSG', this.buffer.name);
      m.tags = m.tags || {};
      m.tags['+draft/reply'] = id;
      m.tags[remove ? '+draft/unreact' : '+draft/react'] = emoji;
      net.ircClient.raw(m);
    }
  }
};